module.exports = __webpack_public_path__ + "static/img/simulations_legende.ab8a0be.png";